import { render, staticRenderFns } from "./horizontal_bar_chart.vue?vue&type=template&id=9dd7c524&scoped=true&"
import script from "./horizontal_bar_chart.vue?vue&type=script&lang=js&"
export * from "./horizontal_bar_chart.vue?vue&type=script&lang=js&"
import style0 from "./horizontal_bar_chart.vue?vue&type=style&index=0&id=9dd7c524&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9dd7c524",
  null
  
)

export default component.exports